import React from 'react'

import { CLASS_PREFIX } from 'src/constants'
import './side_card.scss'

const cls = `${CLASS_PREFIX}project-detail-side-card`

export const SideCard: React.FC = ({ children }) => {
  return <div className={cls}>
    {children}
  </div>
}
